<template>
  <app-layout title="Dashboard">
    <template v-slot:sidenav>
    </template>
         
    <template v-slot:horizonav>
      <nav-bar :scId="selectedId" :scType="selectedType" >
      </nav-bar>
    </template>
  
    <nav class="flex" aria-label="Breadcrumb ">
      <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse mx-5 my-2">
      
        <li>
          <div class="flex items-center">
          
            <a href="#" class="ms-1 text-xs font-medium text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white " style="text-decoration: none;">Projects</a>
          </div>
        </li>
        <li aria-current="page">
          <div class="flex items-center">
            <svg class="rtl:rotate-180 w-2 h-2 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
            </svg>
            <span class="ms-1 text-xs font-medium text-gray-500 md:ms-2 dark:text-gray-400">Product Dashboard</span>
          </div>
        </li>
      </ol>
    </nav>
    <h5 class="mx-5 font-semibold text-gray-600">Insight</h5>
  
    <!-- Tab testing start from here -->
    <div>
      <div class="flex justify-between mx-5">
        <ul class="flex tabs">


              <button type="button"
                class=" tab  px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white" style="text-decoration: none;"  v-for="(tab, index) in tabs" :key="index" @click="activeTab = index" :class="{ ' text-blue-600': activeTab === index }"
              >
              {{ tab.name }}
        </button>


        
          <!-- <li class="tab hidden sm:block border bg-white" data-tab-function="tab2">
            <nav class="flex gap-6" aria-label="Tabs">
              <a
                href="#"
                class="shrink-0 rounded-lg p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200 no-underline"
              >
                Customize
              </a>

            
            </nav>
          </li>
          <li class="tab hidden sm:block border bg-white" data-tab-function="tab3">
            <nav class="flex gap-6" aria-label="Tabs">
              <a
                href="#"
                class="shrink-0 rounded-lg p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200 no-underline"
              >
                Customize
              </a>

            
            </nav>
          </li>
          <li class="tab hidden sm:block border bg-white" data-tab-function="tab4">
            <nav class="flex gap-6" aria-label="Tabs">
              <a
                href="#"
                class="shrink-0 rounded-lg p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200 no-underline"
              >
                Customize
              </a>
            
            </nav>
          </li> -->
          <!-- <li class="tab hidden sm:block border bg-white" data-tab-function="tab5">
            <nav class="flex gap-6" aria-label="Tabs">
              <a
                href="#"
                class="shrink-0 rounded-lg p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200 no-underline"
              >
                Customize
              </a>

            
            </nav>
          </li> -->
        </ul>

        <ul>
          <li class="hidden sm:block border bg-white">
            <nav class="flex gap-6" aria-label="Tabs">
              <a
                href="#"
                class="shrink-0 rounded-lg p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-200 no-underline"
              >
                Customize
              </a>

            
            </nav>
          </li>
        </ul>

       
      </div>
      <div class="tab-content mx-5  py-4">
        <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index" class="content" >
          {{ tab.content }}
        </div>
      </div>
      </div>

    <!-- Tab testing end -->  
          <!-- <div>
            <label v-for="(comp, index) in availableComponents" :key="index">
              <input type="checkbox" :value="comp" v-model="selectedComponents" />
              {{ comp }}
            </label>
          </div> -->
          <!-- <component :is="getComponent('Checkin')" /> -->

        <Popup :isVisible.sync="isPopupVisible"  @hidden="resetPopup"/>

    <div  style="width:100%;height:100%">
        <div style="width:100%;height:100%;" class="px-5">
            <grid-layout :layout.sync="layout"   class="xgrid"
                         :col-num="12"
                         :row-height="30"
                         :is-draggable="draggable"
                         :is-resizable="resizable"
                         :responsive="responsive"
                         :vertical-compact="true"
                         :use-css-transforms="true"
                         @layout-updated="layoutUpdatedEvent"
                         @breakpoint-changed="breakpointChangedEvent"
            >
                <grid-item 
                            v-for="item in layout"
                           :key="item.i"
                           :static="item.static"
                           :x="item.x"
                           :y="item.y"
                           :w="item.w"
                           :h="item.h"
                           :i="item.i"
                           @resized="resizedEvent"
                           @container-resized="containerResizedEvent"
                           drag-allow-from=".vue-draggable-handle"
                           drag-ignore-from=".no-drag" 
                          >
                  <div class="over" style="" ref="child">
                    <div class="bg-white flex justify-between py-1 px-3 vue-draggable-handle" >
                      <div class="text-sm">Overview</div>
                        <div class="flex justify-end icons">
                          <div>
                            <i class="fas fa-sync"></i>
                          </div>
                          &nbsp; &nbsp; &nbsp;
                          <div  @click.prevent="showPopup">
                            <i class="fas fa-solid fa-gear"></i>
                          </div>
                          
                       
                          <!-- <DxPopup ref="popupComponent"  :visible.sync="isPopupVisible"></DxPopup> -->
                          <!-- <tenant-request-panel ref="formRenderer"> </tenant-request-panel> -->

                          &nbsp; &nbsp; &nbsp;
                          <div @click="removeItem(item.i)">
                            <i class="fas fa-times"></i>
                          </div>

                        </div>
                    </div>
                    <!-- <MyCompo :giHeight="getGridItemSize(item.i,'h')" :giWidth="getGridItemSize(item.i,'w')" /> -->
                    
                      <component  
                       :is="item.components" :giHeight="getGridItemSize(item.i,'h')" :giWidth="getGridItemSize(item.i,'w')"
                        />

                       
                  </div>

                </grid-item>
            </grid-layout>
        </div>
    </div>
   
  </app-layout>  
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import JetNavIcon from "@/Jetstream/NavIcon.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import { GridLayout, GridItem } from "vue3-grid-layout";
import NavBar from "@/Layouts/NavBar.vue";
import MyCompo from "@/Pages/DashboardCompo.vue";
import Checkin from "@/Pages/Attendance/Component/Checkin.vue";
import Calender from "@/Pages/Attendance/Component/Calender.vue";
import Leave from "@/Pages/Attendance/Component/Leave.vue";
import AttendHistory from "@/Pages/Attendance/Component/AttendHistory.vue";
import AttendSummary from "@/Pages/Attendance/Component/AttendSummary.vue";
import TimingOverview from "@/Pages/Attendance/Component/TimingOverview.vue";
import Popup from "@/Pages/Popup.vue";

export default {
     props: {
    selectedId:String,
    selectedType:String,
    sessions: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      default: () => ({}),
    },

   },
    components: {
        AppLayout,
        GridLayout,
        GridItem,
        NavBar,
        PageTitle,
        JetButton,
        JetNavLink,
        JetNavIcon,
        MyCompo,
        Checkin,
        Calender,
        Leave,
        AttendHistory,
        AttendSummary,
        TimingOverview,
        Popup,
    },
    data() {
        return {
          // availableComponents: ['AttendHistory', 'AttendSummary', 'Calender', 'Checkin', 'Leave', 'TimingOverview'],
          // selectedComponents: [],
          isPopupVisible: false,
          activeTab:0,
          tabs: [
          { name: 'Yearly', content: 'Content for Yearly' },
          { name: 'Monthly', content: 'Content for Monthly' },
          { name: 'Weekly', content: 'Content for Weekly' },
          { name: 'Days', content: 'Content for Days' },

        ],
            layout: [
                
                { x: 0, y: 0, w: 4, h: 5, i: "0", static: false, components: 'AttendHistory'},
                { x: 2, y: 0, w: 4, h: 5, i: "1", static: false, components: 'Checkin' },
                { x: 4, y: 0, w: 4, h: 5, i: "2", static: false, components: 'Leave'},
                { x: 6, y: 0, w: 4, h: 5, i: "3", static: false, components: 'TimingOverview' },
                { x: 8, y: 0, w: 4, h: 5, i: "4", static: false, components: 'Calender' },
                { x: 8, y: 0, w: 4, h: 5, i: "5", static: false, components: 'AttendSummary' },
                { x: 7, y: 0, w: 4, h: 5, i: "6", static: false, components: 'MyCompo' },
                
            ],
            draggable: true,
            resizable: true,
            responsive: true,
            index: 0,
            sizeArray:[],
        }
    },
    methods: {
    
    showPopup() {
      // this.isPopupVisible = true;
      this.isPopupVisible = !this.isPopupVisible;
    },

   resetPopup(){
    this.isPopupVisible = false;
   },
   
     
      getComponent(componentName) {
      const components = {
        AttendHistory,
        Calender,
        Checkin,
        TimingOverview,
        AttendSummary,
        Leave
      };
      console.log('Component:', componentName, components[componentName]);
      return components[componentName];
    },
    breakpointChangedEvent(){

    },
    layoutUpdatedEvent(){

    },
      resizedEvent(i, newH, newW, newHPx, newWPx)
      {
        this.setGridItemCordinates(i, newH, newW, newHPx, newWPx);
        
      },
      containerResizedEvent(i, newH, newW, newHPx, newWPx)
      {
        this.setGridItemCordinates(i, newH, newW, newHPx, newWPx);
        
      },
      setGridItemCordinates(i, newH, newW, newHPx, newWPx)
      {  
        const newHValue = parseInt(newHPx) - 48;
        const newWValue = parseInt(newWPx) - 20;
        const index = this.sizeArray.findIndex(item => item.id === i);
        if (index >= 0) {
          this.sizeArray[index] = { ...this.sizeArray[index], w:newWValue,h:newHValue };
        }
        else{
          this.sizeArray.push({id:i,w:newWValue,h:newHValue})
        }
      },
      getGridItemSize(id,diection)
      {
          
          const item = this.sizeArray.find(item => item.id == id)
          const size = item ? item[diection] : "0";

          return size;
      },  
      addItem: function () {
            // Add a new item. It must have a unique key!
            /* this.layout.push({
                x: (this.layout.length * 2) % (this.colNum || 12),
                y: this.layout.length + (this.colNum || 12), // puts it at the bottom
                w: 2,
                h: 2,
                i: this.index,
            });
            // Increment the counter to ensure key is always unique.
            this.index++; */
            //this.savelayout();
        },
      removeItem: function (val) {
          const index = this.layout.map(item => item.i).indexOf(val);
          this.layout.splice(index, 1);
      },
      savelayout()
      {
        const route = "test/save-layout";
        const formData = {
          name : "my-preferences",
          type : "Dashboard",
          prefrences : JSON.stringify(this.layout),
        };
        this.$inertia.post('/'+route, formData)
      }
      
    },
    mounted()
    {
    
    // jquary start
  
    // jquary end
        console.log("To check popup page", this.$refs.popupPage);
        this.index = this.layout.length;

        console.log("test",this.sizeArray);
    }

}
</script>

<style scoped>

/* .xgrid::before {
    content: '';
    background-size: calc(calc(100% - 5px) / 12) 40px;
    background-image: linear-gradient(
            to right,
            lightgrey 1px,
            transparent 1px
    ),
    linear-gradient(to bottom, lightgrey 1px, transparent 1px);
    height: calc(100% - 5px);
    width: calc(100% - 5px);
    position: absolute;
    background-repeat: repeat;
    margin:5px;
} */

.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid #d0d0d0;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
.vue-draggable-handle {
   background-color: #eee;
   width:100%;
   height: 30px;
   cursor:all-scroll;
}

.over {
  width: 100%;
  height:100%;
  position: absolute;
  overflow: hidden;
  /* opacity: 0.8; */
 margin-bottom: 20rem;
 background: #dbf4fa;
}
.columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
}
.icons i{
  height:0.1rem;
  font-size: 0.7rem;
  cursor: pointer !important;
}
ul {
  margin-top: 0;
  margin-bottom: 0.1rem;
}

</style>